export enum MetricOPEEnum {
  DelMetric = 'delMetric',
  GetMetricInstances = 'getMetricInstances',
  ExecWM2E = 'execWM2E'
}
